export default __webpack_public_path__ + "static/media/offeredposition.83b436a8.svg";